(() => {
  'use strict';

  const modal = document.getElementById('CxtKlaviyoModal');
  const triggerSelector = '[data-cxt-klaviyo-modal-trigger]';

  if (!modal) return;

  let lastTrigger = null;

  const setExpandedState = (isExpanded) => {
    document.querySelectorAll(triggerSelector).forEach((trigger) => {
      trigger.setAttribute('aria-expanded', String(isExpanded));
    });
  };

  const restoreFocus = () => {
    if (lastTrigger && document.contains(lastTrigger)) {
      lastTrigger.focus({ preventScroll: true });
    }

    lastTrigger = null;
    setExpandedState(false);
  };

  const openModal = (trigger) => {
    lastTrigger = trigger;

    if (!modal.open) {
      modal.showModal();
    }

    setExpandedState(true);

    window.requestAnimationFrame(() => {
      const closeButton = modal.querySelector('[data-cxt-klaviyo-modal-close]');

      if (closeButton) {
        closeButton.focus({ preventScroll: true });
      }
    });
  };

  const closeModal = () => {
    if (modal.open) {
      setExpandedState(false);
      modal.close();
    }
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const trigger = event.target.closest(triggerSelector);

    if (trigger) {
      event.preventDefault();
      openModal(trigger);
      return;
    }

    if (event.target.closest('[data-cxt-klaviyo-modal-close]')) {
      closeModal();
    }
  });

  modal.addEventListener('click', (event) => {
    if (event.target === modal) {
      closeModal();
    }
  });

  modal.addEventListener('cancel', (event) => {
    event.preventDefault();
    closeModal();
  });

  modal.addEventListener('close', restoreFocus);
})();
